'use client';
import { useMemo } from 'react';
import { headerMenuItems } from './header-menu-items.js';
import { portalLinks } from './portal-links.js';
import { signOut } from './sign-out.js';
import { useHeaderData } from './use-header-data.js';
/**
 * The shared header menu as data, for a track frontend that draws its own
 * dropdown (HUB-125 D5). Same inputs as `TrackframeHeader` (hub origin, the
 * track's hub-proxy mount point, auth headers); same data source as the
 * built-in menu — `TrackframeHeaderMenu` renders exactly `items`.
 *
 *   const { identity, items, signOut } = useTrackframeHeaderMenu({
 *     hubBaseUrl: 'https://hub.example.com',
 *     hubProxyBaseUrl: '/hub',
 *   });
 *   items.map((i) => <a key={i.id} href={i.url}>{i.title}</a>)
 */
export function useTrackframeHeaderMenu(options = {}) {
    const { hubBaseUrl, hubProxyBaseUrl, getAuthHeaders, signOut: signOutOpts } = options;
    const { identity, branding, tracks, loading, error } = useHeaderData({
        hubBaseUrl,
        hubProxyBaseUrl,
        getAuthHeaders,
    });
    const isAdmin = identity?.roles?.includes('admin') ?? false;
    const appBaseUrl = branding?.appBaseUrl;
    const landingUrl = branding?.landingUrl;
    const items = useMemo(() => headerMenuItems({ tracks, links: portalLinks({ appBaseUrl, isAdmin, landingUrl }) }), [tracks, appBaseUrl, isAdmin, landingUrl]);
    return {
        identity,
        branding,
        items,
        loading,
        error,
        signOut: () => {
            void signOut({ hubBaseUrl, ...signOutOpts });
        },
    };
}
//# sourceMappingURL=use-header-menu.js.map